import getStartTime from '../getStartTime'
import { YOUTUBE_BE, YOUTUBE_COM } from '../isYoutube'

export const parseYouTubeUrl = (rawUrl: string) => {
  const url = new URL(rawUrl)

  // 1) Standard watch URL
  if (url.hostname.includes(YOUTUBE_COM) && url.pathname === '/watch') {
    const v = url.searchParams.get('v')
    if (v) {
      return { videoId: v, startSeconds: getStartTime(url) }
    }
  }

  // 2) youtu.be short link
  else if (url.hostname === YOUTUBE_BE) {
    const id = url.pathname.slice(1) // "/VIDEO_ID"
    if (id) {
      return { videoId: id, startSeconds: getStartTime(url) }
    }
  }

  // 3) Shorts
  // e.g. https://www.youtube.com/shorts/VIDEO_ID[, …]
  else if (
    url.hostname.includes(YOUTUBE_COM) &&
    url.pathname.startsWith('/shorts/')
  ) {
    const id = url.pathname.split('/')[2] // "VIDEO_ID"
    if (id) {
      return { videoId: id, startSeconds: getStartTime(url) }
    }
  }

  // 4) Live
  else if (url.pathname.startsWith('/live/')) {
    const id = url.pathname.split('/')[2] // "VIDEO_ID"
    if (id) {
      return { videoId: id, startSeconds: getStartTime(url) }
    }
  }

  // 5) Embed-safe fallback: sometimes people paste already-embedded or other forms
  // Try to read "v" param anywhere:
  const v = url.searchParams.get('v')
  if (v) return { videoId: v, startSeconds: getStartTime(url) }

  return { videoId: null }
}
